<template>
    <div class="dashboard-solicitudes">
        <!-- Header Principal -->
        <div class="ibox">
            <div class="ibox-title dashboard-header">
                <h4>
                    <i class="fal fa-chart-line"></i> Dashboard de Gestión de
                    Solicitudes
                </h4>
                <p class="mb-0 dashboard-header-subtitle">
                    Sistema de Atención al Usuario - CAPREDENA | División de
                    Atención al Usuario
                </p>
                <div class="ibox-tools">
                    <button
                        @click="regenerateFakeData"
                        class="btn btn-sm btn-outline-light"
                        :disabled="loading"
                        title="Regenerar datos fake"
                    >
                        <i class="fal fa-sync-alt"></i> Regenerar Datos
                    </button>
                    <!--
          <span class="badge badge-light ml-2" v-if="!loading">
            <i class="fal fa-database"></i> Datos Simulados
          </span>
          -->
                </div>
            </div>
        </div>

        <!-- Selector de Período -->
        <PeriodSelector
            :period="selectedPeriod"
            @period-changed="onPeriodChanged"
            @custom-period-applied="onCustomPeriodApplied"
        />

        <!-- KPIs Principales -->
        <KPICards :kpis="dashboardData.kpis" />

        <!-- Estado de agentes en tiempo real -->
        <RealTimeAgentStatus />

        <!-- Gráficos Principales -->
        <!--
    <MainCharts
      :evolucion-temporal="dashboardData.evolucionTemporal"
      :tipo-analisis="dashboardData.tipoAnalisis"
      :tema-analisis="dashboardData.temaAnalisis"
      :canal-analisis="dashboardData.canalAnalisis"
      :prioridad-analisis="dashboardData.prioridadDistribucion"
      :satisfaccion-por-tipo="dashboardData.satisfaccionPorTipo"
      :satisfaccion-por-tema="dashboardData.satisfaccionPorTema"
      :fuentes-solicitudes="dashboardData.fuentesSolicitudes"
    />
    -->

        <!-- Gráfico de Análisis por Tema (Componente Independiente) -->
        <ThemeAnalysisChart :tema-analisis="dashboardData.temaAnalisis" />

        <!-- Gráfico de Solicitudes Vencidas por Tema -->
        <OverdueRequestsChart :overdue-data="dashboardData.temaVencidas" />

        <!-- Gráfico Demográfico por Región -->
        <DemographicsChart
            :demographics-data="dashboardData.demographicsData"
        />

        <!-- Métricas SLA -->
        <!--
    <SLAMetrics :sla-metrics="dashboardData.slaMetrics" />
    -->

        <!-- Mapa de Calor SLA -->
        <!-- Mapa de Calor SLA -->

        <!--
    <SLAHeatmap :sla-heatmap="dashboardData.slaHeatmap" />
    -->

        <!-- Rendimiento de Agentes -->
        <AgentPerformance
            :agente-performance="dashboardData.agentePerformance"
            :period="selectedPeriod"
            :from="
                customDates && selectedPeriod === 'personalizado'
                    ? customDates.startDate
                    : null
            "
            :to="
                customDates && selectedPeriod === 'personalizado'
                    ? customDates.endDate
                    : null
            "
        />

        <!-- Análisis de Workflow -->
        <!--
    <WorkflowAnalysis :workflow-analisis="dashboardData.workflowAnalisis" />
     -->

        <!-- Métricas de Satisfacción -->
        <!--
    <SatisfactionMetrics :satisfaccion-metrics="dashboardData.satisfaccionMetrics" />
    -->

        <!-- Métricas de Negocio -->
        <!--
    <BusinessMetrics :negocio-metrics="dashboardData.negocioMetrics" />
     -->

        <!-- Alertas y Escalaciones -->
        <!--
    <AlertsEscalations
      :alertas="dashboardData.alertas"
      :escalamientos="dashboardData.escalamientos"
    />
    -->

        <!-- Resumen del Período -->
        <!--
    <PeriodSummary
      :periodo="selectedPeriod"
      :fecha-inicio="dashboardData.fechaInicio"
      :fecha-fin="dashboardData.fechaFin"
    />
    -->

        <!-- Loading Overlay -->
        <div v-if="loading" class="loading-overlay">
            <div class="loading-content">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
                <p>Cargando datos...</p>
            </div>
        </div>
    </div>
</template>

<script>
import PeriodSelector from "./components/PeriodSelector.vue";
import KPICards from "./components/KPICards.vue";
import SLAMetrics from "./components/SLAMetrics.vue";
import {
    fakeDataConfig,
    generateRandomInRange,
    generateRandomDecimal,
} from "./config/fakeDataConfig.js";
import MainCharts from "./components/MainCharts.vue";
import SLAHeatmap from "./components/SLAHeatmap.vue";
import AgentPerformance from "./components/AgentPerformance.vue";
import WorkflowAnalysis from "./components/WorkflowAnalysis.vue";
import SatisfactionMetrics from "./components/SatisfactionMetrics.vue";
import BusinessMetrics from "./components/BusinessMetrics.vue";
import AlertsEscalations from "./components/AlertsEscalations.vue";
import PeriodSummary from "./components/PeriodSummary.vue";
import ThemeAnalysisChart from "./components/ThemeAnalysisChart.vue";
import OverdueRequestsChart from "./components/OverdueRequestsChart.vue";
import DemographicsChart from "./components/DemographicsChart.vue";
import RealTimeAgentStatus from "./components/RealTimeAgentStatus.vue";

export default {
    name: "DashboardSolicitudes",
    components: {
        PeriodSelector,
        KPICards,
        SLAMetrics,
        MainCharts,
        SLAHeatmap,
        AgentPerformance,
        WorkflowAnalysis,
        SatisfactionMetrics,
        BusinessMetrics,
        AlertsEscalations,
        PeriodSummary,
        ThemeAnalysisChart,
        OverdueRequestsChart,
        DemographicsChart,
        RealTimeAgentStatus,
    },
    data() {
        return {
            selectedPeriod: "mes",
            customDates: null,
            loading: false,
            dashboardData: {
                kpis: {},
                slaMetrics: {},
                calidadMetrics: {},
                tipoAnalisis: [],
                temaAnalisis: [],
                temaVencidas: [],
                canalAnalisis: [],
                agentePerformance: [],
                cargaTrabajo: {},
                evolucionTemporal: [],
                slaHeatmap: [],
                alertas: {},
                escalamientos: {},
                prioridadDistribucion: [],
                workflowAnalisis: {},
                satisfaccionMetrics: {},
                negocioMetrics: {},
                periodo: "mes",
                fechaInicio: null,
                fechaFin: null,
            },
            refreshInterval: null,
        };
    },
    mounted() {
        this.loadDashboardData();
        this.initializeRealTimeUpdates();
    },
    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    },
    methods: {
        // Generar datos fake realistas para el dashboard
        generateFakeData() {
            const period = this.selectedPeriod;
            const baseMultiplier =
                period === "semana" ? 0.25 : period === "mes" ? 1 : 3;

            return {
                kpis: {
                    // KPIs Principales - Mantenidos
                    total:
                        generateRandomInRange(
                            fakeDataConfig.kpiRanges.total.min,
                            fakeDataConfig.kpiRanges.total.max
                        ) * baseMultiplier,
                    resueltas:
                        generateRandomInRange(
                            fakeDataConfig.kpiRanges.resueltas.min,
                            fakeDataConfig.kpiRanges.resueltas.max
                        ) * baseMultiplier,
                    tasa_crecimiento: generateRandomDecimal(
                        fakeDataConfig.kpiRanges.tasa_crecimiento.min,
                        fakeDataConfig.kpiRanges.tasa_crecimiento.max
                    ),
                    tiempo_promedio: generateRandomDecimal(
                        fakeDataConfig.kpiRanges.tiempo_promedio.min,
                        fakeDataConfig.kpiRanges.tiempo_promedio.max
                    ),

                    // KPIs Modificados
                    solicitudes_por_vencer:
                        generateRandomInRange(
                            fakeDataConfig.kpiRanges.pendiente_resolucion.min,
                            fakeDataConfig.kpiRanges.pendiente_resolucion.max
                        ) *
                            baseMultiplier +
                        generateRandomInRange(
                            fakeDataConfig.kpiRanges.en_proceso.min,
                            fakeDataConfig.kpiRanges.en_proceso.max
                        ) *
                            baseMultiplier,

                    // Nueva fórmula para tasa de respuesta: (resueltas / total) * 100
                    tasa_respuesta: 0, // Se calculará después

                    // KPIs de SLA - Nuevos
                    sla_cumplidos: 0, // Se calculará después
                    sla_cumplidos_porcentaje: 0, // Se calculará después
                    sla_no_cumplidos: 0, // Se calculará después
                    sla_no_cumplidos_porcentaje: 0, // Se calculará después
                },
                slaMetrics: {
                    cumplimiento_general: generateRandomInRange(
                        fakeDataConfig.slaRanges.cumplimiento_general.min,
                        fakeDataConfig.slaRanges.cumplimiento_general.max
                    ),
                    solicitudes_vencidas:
                        generateRandomInRange(
                            fakeDataConfig.slaRanges.solicitudes_vencidas.min,
                            fakeDataConfig.slaRanges.solicitudes_vencidas.max
                        ) * baseMultiplier,
                    solicitudes_proximas_vencer:
                        generateRandomInRange(
                            fakeDataConfig.slaRanges.solicitudes_proximas_vencer
                                .min,
                            fakeDataConfig.slaRanges.solicitudes_proximas_vencer
                                .max
                        ) * baseMultiplier,
                    sla_criticos:
                        generateRandomInRange(
                            fakeDataConfig.slaRanges.sla_criticos.min,
                            fakeDataConfig.slaRanges.sla_criticos.max
                        ) * baseMultiplier,
                    tiempo_resolucion_promedio: generateRandomInRange(
                        fakeDataConfig.slaRanges.tiempo_resolucion_promedio.min,
                        fakeDataConfig.slaRanges.tiempo_resolucion_promedio.max
                    ),
                    tiempo_asignacion_promedio: generateRandomInRange(
                        fakeDataConfig.slaRanges.tiempo_asignacion_promedio.min,
                        fakeDataConfig.slaRanges.tiempo_asignacion_promedio.max
                    ),
                    tiempo_escalacion_promedio: generateRandomInRange(
                        fakeDataConfig.slaRanges.tiempo_escalacion_promedio.min,
                        fakeDataConfig.slaRanges.tiempo_escalacion_promedio.max
                    ),
                    cumplimiento_alta: generateRandomInRange(
                        fakeDataConfig.slaRanges.cumplimiento_alta.min,
                        fakeDataConfig.slaRanges.cumplimiento_alta.max
                    ),
                    cumplimiento_media: generateRandomInRange(
                        fakeDataConfig.slaRanges.cumplimiento_media.min,
                        fakeDataConfig.slaRanges.cumplimiento_media.max
                    ),
                    cumplimiento_baja: generateRandomInRange(
                        fakeDataConfig.slaRanges.cumplimiento_baja.min,
                        fakeDataConfig.slaRanges.cumplimiento_baja.max
                    ),
                },
                calidadMetrics: {
                    satisfaccion_promedio: (Math.random() * 1 + 3.5).toFixed(1),
                    tiempo_resolucion_objetivo: Math.floor(
                        Math.random() * 4 + 6
                    ),
                    calidad_resolucion: Math.floor(Math.random() * 15 + 80),
                    reincidencia_rate: (Math.random() * 10 + 5).toFixed(1),
                },
                tipoAnalisis: [
                    {
                        nombre: "Consulta",
                        cantidad:
                            Math.floor(Math.random() * 200 + 300) *
                            baseMultiplier,
                        porcentaje: 35,
                    },
                    {
                        nombre: "Sugerencia",
                        cantidad:
                            Math.floor(Math.random() * 150 + 200) *
                            baseMultiplier,
                        porcentaje: 25,
                    },
                    {
                        nombre: "Felicitaciones",
                        cantidad:
                            Math.floor(Math.random() * 100 + 150) *
                            baseMultiplier,
                        porcentaje: 20,
                    },
                    {
                        nombre: "Reclamo",
                        cantidad:
                            Math.floor(Math.random() * 80 + 100) *
                            baseMultiplier,
                        porcentaje: 15,
                    },
                    {
                        nombre: "Otros",
                        cantidad:
                            Math.floor(Math.random() * 50 + 80) *
                            baseMultiplier,
                        porcentaje: 5,
                    },
                ],
                satisfaccionPorTipo: [
                    {
                        tipo: "Consulta",
                        satisfaccion: (Math.random() * 0.5 + 4.0).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 200 + 300) *
                            baseMultiplier,
                        color: "#28a745",
                    },
                    {
                        tipo: "Sugerencia",
                        satisfaccion: (Math.random() * 0.5 + 4.0).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 150 + 200) *
                            baseMultiplier,
                        color: "#28a745",
                    },
                    {
                        tipo: "Felicitaciones",
                        satisfaccion: (Math.random() * 0.5 + 4.5).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 100 + 150) *
                            baseMultiplier,
                        color: "#28a745",
                    },
                    {
                        tipo: "Reclamo",
                        satisfaccion: (Math.random() * 0.8 + 3.5).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 80 + 100) *
                            baseMultiplier,
                        color: "#17a2b8",
                    },
                    {
                        tipo: "Otros",
                        satisfaccion: (Math.random() * 0.5 + 4.0).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 50 + 80) *
                            baseMultiplier,
                        color: "#28a745",
                    },
                ],
                satisfaccionPorTema: [
                    {
                        tema: "Pensiones y Asignación Familiar",
                        satisfaccion: (Math.random() * 0.8 + 3.8).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 250 + 350) *
                            baseMultiplier,
                        color: "#1f4e79",
                    },
                    {
                        tema: "Resoluciones Judiciales y Retenciones",
                        satisfaccion: (Math.random() * 0.6 + 3.5).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 200 + 250) *
                            baseMultiplier,
                        color: "#dc3545",
                    },
                    {
                        tema: "Poderes y Mandatos",
                        satisfaccion: (Math.random() * 0.7 + 3.9).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 150 + 200) *
                            baseMultiplier,
                        color: "#28a745",
                    },
                    {
                        tema: "Imposiciones Previsionales y Desahucio",
                        satisfaccion: (Math.random() * 0.6 + 3.6).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 120 + 180) *
                            baseMultiplier,
                        color: "#ffc107",
                    },
                    {
                        tema: "Préstamos",
                        satisfaccion: (Math.random() * 0.8 + 3.7).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 100 + 150) *
                            baseMultiplier,
                        color: "#17a2b8",
                    },
                    {
                        tema: "Asistencia Social",
                        satisfaccion: (Math.random() * 0.9 + 4.0).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 80 + 120) *
                            baseMultiplier,
                        color: "#6f42c1",
                    },
                    {
                        tema: "Sistema de Salud Capredena y Fondo Solidario",
                        satisfaccion: (Math.random() * 0.7 + 3.8).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 60 + 100) *
                            baseMultiplier,
                        color: "#20c997",
                    },
                    {
                        tema: "Centros de Salud y Rehabilitación Capredena",
                        satisfaccion: (Math.random() * 0.8 + 4.1).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 40 + 80) *
                            baseMultiplier,
                        color: "#fd7e14",
                    },
                    {
                        tema: "Otros",
                        satisfaccion: (Math.random() * 0.5 + 3.9).toFixed(1),
                        cantidad:
                            Math.floor(Math.random() * 30 + 50) *
                            baseMultiplier,
                        color: "#6c757d",
                    },
                ],
                temaAnalisis: [
                    {
                        nombre: "Pensiones y Asignación Familiar",
                        pendiente:
                            Math.floor(Math.random() * 50 + 80) *
                            baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 60 + 90) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 140 + 180) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 15 + 25) *
                            baseMultiplier,
                        total: 0, // Se calculará después
                    },
                    {
                        nombre: "Resoluciones Judiciales y Retenciones",
                        pendiente:
                            Math.floor(Math.random() * 40 + 60) *
                            baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 50 + 70) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 110 + 120) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 12 + 20) *
                            baseMultiplier,
                        total: 0,
                    },
                    {
                        nombre: "Poderes y Mandatos",
                        pendiente:
                            Math.floor(Math.random() * 30 + 50) *
                            baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 40 + 60) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 80 + 90) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 8 + 15) * baseMultiplier,
                        total: 0,
                    },
                    {
                        nombre: "Imposiciones Previsionales y Desahucio",
                        pendiente:
                            Math.floor(Math.random() * 25 + 40) *
                            baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 35 + 50) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 60 + 90) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 6 + 12) * baseMultiplier,
                        total: 0,
                    },
                    {
                        nombre: "Préstamos",
                        pendiente:
                            Math.floor(Math.random() * 20 + 30) *
                            baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 25 + 40) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 55 + 80) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 5 + 10) * baseMultiplier,
                        total: 0,
                    },
                    {
                        nombre: "Asistencia Social",
                        pendiente:
                            Math.floor(Math.random() * 15 + 25) *
                            baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 20 + 30) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 45 + 65) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 4 + 8) * baseMultiplier,
                        total: 0,
                    },
                    {
                        nombre: "Sistema de Salud Capredena y Fondo Solidario",
                        pendiente:
                            Math.floor(Math.random() * 10 + 20) *
                            baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 15 + 25) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 35 + 55) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 3 + 6) * baseMultiplier,
                        total: 0,
                    },
                    {
                        nombre: "Centros de Salud y Rehabilitación Capredena",
                        pendiente:
                            Math.floor(Math.random() * 8 + 15) * baseMultiplier,
                        en_curso:
                            Math.floor(Math.random() * 12 + 20) *
                            baseMultiplier,
                        resuelto:
                            Math.floor(Math.random() * 20 + 45) *
                            baseMultiplier,
                        vencidas:
                            Math.floor(Math.random() * 2 + 4) * baseMultiplier,
                        total: 0,
                    },
                ],
                temaVencidas: [
                    {
                        nombre: "Pensiones y Asignación Familiar",
                        vencidas:
                            Math.floor(Math.random() * 15 + 25) *
                            baseMultiplier,
                    },
                    {
                        nombre: "Resoluciones Judiciales y Retenciones",
                        vencidas:
                            Math.floor(Math.random() * 12 + 20) *
                            baseMultiplier,
                    },
                    {
                        nombre: "Poderes y Mandatos",
                        vencidas:
                            Math.floor(Math.random() * 8 + 15) * baseMultiplier,
                    },
                    {
                        nombre: "Imposiciones Previsionales y Desahucio",
                        vencidas:
                            Math.floor(Math.random() * 6 + 12) * baseMultiplier,
                    },
                    {
                        nombre: "Préstamos",
                        vencidas:
                            Math.floor(Math.random() * 5 + 10) * baseMultiplier,
                    },
                    {
                        nombre: "Asistencia Social",
                        vencidas:
                            Math.floor(Math.random() * 4 + 8) * baseMultiplier,
                    },
                    {
                        nombre: "Sistema de Salud Capredena y Fondo Solidario",
                        vencidas:
                            Math.floor(Math.random() * 3 + 6) * baseMultiplier,
                    },
                    {
                        nombre: "Centros de Salud y Rehabilitación Capredena",
                        vencidas:
                            Math.floor(Math.random() * 2 + 4) * baseMultiplier,
                    },
                ],
                canalAnalisis: [
                    {
                        canal: "Portal Web",
                        cantidad:
                            Math.floor(Math.random() * 300 + 400) *
                            baseMultiplier,
                        porcentaje: 45,
                    },
                    {
                        canal: "Correo Electrónico",
                        cantidad:
                            Math.floor(Math.random() * 200 + 250) *
                            baseMultiplier,
                        porcentaje: 30,
                    },
                    {
                        canal: "Teléfono",
                        cantidad:
                            Math.floor(Math.random() * 100 + 150) *
                            baseMultiplier,
                        porcentaje: 15,
                    },
                    {
                        canal: "Chat en Vivo",
                        cantidad:
                            Math.floor(Math.random() * 80 + 100) *
                            baseMultiplier,
                        porcentaje: 10,
                    },
                ],
                fuentesSolicitudes: [
                    {
                        fuente: "Correo Electrónico",
                        cantidad:
                            Math.floor(Math.random() * 250 + 350) *
                            baseMultiplier,
                        porcentaje: 35,
                        color: "#17a2b8",
                        tendencia: "ascendente",
                    },
                    {
                        fuente: "Aplicación Móvil",
                        cantidad:
                            Math.floor(Math.random() * 200 + 300) *
                            baseMultiplier,
                        porcentaje: 28,
                        color: "#28a745",
                        tendencia: "ascendente",
                    },
                    {
                        fuente: "Portal de Solicitudes",
                        cantidad:
                            Math.floor(Math.random() * 150 + 250) *
                            baseMultiplier,
                        porcentaje: 22,
                        color: "#ffc107",
                        tendencia: "estable",
                    },
                    {
                        fuente: "Portal Capredena",
                        cantidad:
                            Math.floor(Math.random() * 100 + 200) *
                            baseMultiplier,
                        porcentaje: 15,
                        color: "#1f4e79",
                        tendencia: "descendente",
                    },
                ],
                demographicsData: [
                    {
                        region: "Región Metropolitana",
                        cantidad:
                            Math.floor(Math.random() * 500 + 800) *
                            baseMultiplier,
                        porcentaje: 0, // Se calculará después
                    },
                    {
                        region: "Valparaíso",
                        cantidad:
                            Math.floor(Math.random() * 200 + 300) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Biobío",
                        cantidad:
                            Math.floor(Math.random() * 150 + 250) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Antofagasta",
                        cantidad:
                            Math.floor(Math.random() * 100 + 180) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "La Araucanía",
                        cantidad:
                            Math.floor(Math.random() * 80 + 150) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Coquimbo",
                        cantidad:
                            Math.floor(Math.random() * 70 + 120) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Los Lagos",
                        cantidad:
                            Math.floor(Math.random() * 60 + 100) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Maule",
                        cantidad:
                            Math.floor(Math.random() * 50 + 90) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Atacama",
                        cantidad:
                            Math.floor(Math.random() * 40 + 70) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "O'Higgins",
                        cantidad:
                            Math.floor(Math.random() * 35 + 60) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Aysén",
                        cantidad:
                            Math.floor(Math.random() * 20 + 40) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Magallanes",
                        cantidad:
                            Math.floor(Math.random() * 15 + 30) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Arica y Parinacota",
                        cantidad:
                            Math.floor(Math.random() * 25 + 45) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Tarapacá",
                        cantidad:
                            Math.floor(Math.random() * 30 + 50) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                    {
                        region: "Los Ríos",
                        cantidad:
                            Math.floor(Math.random() * 25 + 40) *
                            baseMultiplier,
                        porcentaje: 0,
                    },
                ],
                agentePerformance: fakeDataConfig.agentes.map((agente) => {
                    // Generar datos base para cada agente
                    const resueltas =
                        generateRandomInRange(
                            agente.performance.min,
                            agente.performance.max
                        ) * baseMultiplier;
                    const pendientes =
                        generateRandomInRange(5, 25) * baseMultiplier;
                    const en_proceso =
                        generateRandomInRange(8, 30) * baseMultiplier;
                    const vencidas =
                        generateRandomInRange(2, 15) * baseMultiplier;
                    const por_vencer =
                        generateRandomInRange(3, 20) * baseMultiplier;
                    const total_solicitudes =
                        resueltas +
                        pendientes +
                        en_proceso +
                        vencidas +
                        por_vencer;

                    return {
                        nombre: agente.nombre,
                        total_solicitudes: total_solicitudes,
                        pendientes: pendientes,
                        en_proceso: en_proceso,
                        resueltas: resueltas,
                        vencidas: vencidas,
                        por_vencer: por_vencer,
                        tiempo_promedio: generateRandomDecimal(
                            agente.tiempo.min,
                            agente.tiempo.max
                        ),
                    };
                }),
                cargaTrabajo: {
                    total_agentes: fakeDataConfig.cargaTrabajo.total_agentes,
                    agente_activo: generateRandomInRange(
                        fakeDataConfig.cargaTrabajo.agente_activo.min,
                        fakeDataConfig.cargaTrabajo.agente_activo.max
                    ),
                    solicitudes_por_agente:
                        generateRandomInRange(
                            fakeDataConfig.cargaTrabajo.solicitudes_por_agente
                                .min,
                            fakeDataConfig.cargaTrabajo.solicitudes_por_agente
                                .max
                        ) * baseMultiplier,
                    tiempo_ocioso_promedio: generateRandomDecimal(
                        fakeDataConfig.cargaTrabajo.tiempo_ocioso_promedio.min,
                        fakeDataConfig.cargaTrabajo.tiempo_ocioso_promedio.max
                    ),
                },
                evolucionTemporal: this.generateTemporalData(period),
                slaHeatmap: this.generateSLAHeatmap(period),
                alertas: {
                    criticas:
                        generateRandomInRange(
                            fakeDataConfig.alertas.criticas.min,
                            fakeDataConfig.alertas.criticas.max
                        ) * baseMultiplier,
                    advertencias:
                        generateRandomInRange(
                            fakeDataConfig.alertas.advertencias.min,
                            fakeDataConfig.alertas.advertencias.max
                        ) * baseMultiplier,
                    informativas:
                        generateRandomInRange(
                            fakeDataConfig.alertas.informativas.min,
                            fakeDataConfig.alertas.informativas.max
                        ) * baseMultiplier,
                    vencidas: generateRandomInRange(5, 25) * baseMultiplier,
                },
                escalamientos: {
                    total:
                        generateRandomInRange(
                            fakeDataConfig.escalamientos.total.min,
                            fakeDataConfig.escalamientos.total.max
                        ) * baseMultiplier,
                    por_prioridad:
                        generateRandomInRange(
                            fakeDataConfig.escalamientos.por_prioridad.min,
                            fakeDataConfig.escalamientos.por_prioridad.max
                        ) * baseMultiplier,
                    por_tiempo:
                        generateRandomInRange(
                            fakeDataConfig.escalamientos.por_tiempo.min,
                            fakeDataConfig.escalamientos.por_tiempo.max
                        ) * baseMultiplier,
                    por_complejidad:
                        generateRandomInRange(
                            fakeDataConfig.escalamientos.por_complejidad.min,
                            fakeDataConfig.escalamientos.por_complejidad.max
                        ) * baseMultiplier,
                },
                prioridadDistribucion: [
                    {
                        prioridad: "Alta",
                        cantidad:
                            Math.floor(Math.random() * 50 + 100) *
                            baseMultiplier,
                        porcentaje: 20,
                    },
                    {
                        prioridad: "Media",
                        cantidad:
                            Math.floor(Math.random() * 150 + 200) *
                            baseMultiplier,
                        porcentaje: 50,
                    },
                    {
                        prioridad: "Baja",
                        cantidad:
                            Math.floor(Math.random() * 100 + 150) *
                            baseMultiplier,
                        porcentaje: 30,
                    },
                ],
                workflowAnalisis: {
                    estados: [
                        {
                            estado: "Nueva",
                            cantidad:
                                Math.floor(Math.random() * 100 + 150) *
                                baseMultiplier,
                            porcentaje: 25,
                        },
                        {
                            estado: "Asignada",
                            cantidad:
                                Math.floor(Math.random() * 80 + 120) *
                                baseMultiplier,
                            porcentaje: 20,
                        },
                        {
                            estado: "En Proceso",
                            cantidad:
                                Math.floor(Math.random() * 120 + 180) *
                                baseMultiplier,
                            porcentaje: 30,
                        },
                        {
                            estado: "Pendiente",
                            cantidad:
                                Math.floor(Math.random() * 60 + 100) *
                                baseMultiplier,
                            porcentaje: 15,
                        },
                        {
                            estado: "Resuelta",
                            cantidad:
                                Math.floor(Math.random() * 200 + 300) *
                                baseMultiplier,
                            porcentaje: 10,
                        },
                    ],
                    transiciones: [
                        {
                            desde: "Nueva",
                            hacia: "Asignada",
                            cantidad:
                                Math.floor(Math.random() * 80 + 120) *
                                baseMultiplier,
                        },
                        {
                            desde: "Asignada",
                            hacia: "En Proceso",
                            cantidad:
                                Math.floor(Math.random() * 70 + 100) *
                                baseMultiplier,
                        },
                        {
                            desde: "En Proceso",
                            hacia: "Resuelta",
                            cantidad:
                                Math.floor(Math.random() * 150 + 200) *
                                baseMultiplier,
                        },
                    ],
                },
                satisfaccionMetrics: {
                    promedio_general: (Math.random() * 1 + 3.8).toFixed(1),
                    distribucion: [
                        {
                            puntuacion: 5,
                            cantidad:
                                Math.floor(Math.random() * 200 + 300) *
                                baseMultiplier,
                            porcentaje: 45,
                        },
                        {
                            puntuacion: 4,
                            cantidad:
                                Math.floor(Math.random() * 150 + 200) *
                                baseMultiplier,
                            porcentaje: 35,
                        },
                        {
                            puntuacion: 3,
                            cantidad:
                                Math.floor(Math.random() * 50 + 80) *
                                baseMultiplier,
                            porcentaje: 15,
                        },
                        {
                            puntuacion: 2,
                            cantidad:
                                Math.floor(Math.random() * 20 + 30) *
                                baseMultiplier,
                            porcentaje: 3,
                        },
                        {
                            puntuacion: 1,
                            cantidad:
                                Math.floor(Math.random() * 10 + 20) *
                                baseMultiplier,
                            porcentaje: 2,
                        },
                    ],
                    tendencia: "ascendente",
                },
                negocioMetrics: {
                    costo_por_solicitud: generateRandomDecimal(
                        fakeDataConfig.metricasNegocio.costo_por_solicitud.min,
                        fakeDataConfig.metricasNegocio.costo_por_solicitud.max,
                        2
                    ),
                    roi_servicio: generateRandomDecimal(
                        fakeDataConfig.metricasNegocio.roi_servicio.min,
                        fakeDataConfig.metricasNegocio.roi_servicio.max
                    ),
                    satisfaccion_cliente: generateRandomDecimal(
                        fakeDataConfig.metricasNegocio.satisfaccion_cliente.min,
                        fakeDataConfig.metricasNegocio.satisfaccion_cliente.max
                    ),
                    tiempo_resolucion_objetivo: generateRandomInRange(
                        fakeDataConfig.metricasNegocio
                            .tiempo_resolucion_objetivo.min,
                        fakeDataConfig.metricasNegocio
                            .tiempo_resolucion_objetivo.max
                    ),
                },
                periodo: period,
                fechaInicio: this.getDateRange(period).inicio,
                fechaFin: this.getDateRange(period).fin,
            };
        },

        // Calcular KPIs derivados después de generar los datos base
        calculateDerivedKPIs(data) {
            const total = data.kpis.total;
            const resueltas = data.kpis.resueltas;

            // Calcular tasa de respuesta: (resueltas / total) * 100
            data.kpis.tasa_respuesta =
                total > 0 ? Math.round((resueltas / total) * 100 * 10) / 10 : 0;

            // Calcular SLA cumplidos/no cumplidos (simulando 85% cumplimiento promedio)
            const cumplimientoSLA = generateRandomDecimal(80, 90); // 80-90% de cumplimiento
            data.kpis.sla_cumplidos = Math.round(
                resueltas * (cumplimientoSLA / 100)
            );
            data.kpis.sla_cumplidos_porcentaje =
                Math.round(cumplimientoSLA * 10) / 10;
            data.kpis.sla_no_cumplidos = resueltas - data.kpis.sla_cumplidos;
            data.kpis.sla_no_cumplidos_porcentaje =
                Math.round((100 - cumplimientoSLA) * 10) / 10;

            // Calcular totales para temaAnalisis
            data.temaAnalisis.forEach((tema) => {
                tema.total = tema.pendiente + tema.en_curso + tema.resuelto;
            });

            // Calcular porcentajes para datos demográficos
            const totalDemographics = data.demographicsData.reduce(
                (sum, region) => sum + region.cantidad,
                0
            );
            data.demographicsData.forEach((region) => {
                region.porcentaje =
                    totalDemographics > 0
                        ? Math.round(
                              (region.cantidad / totalDemographics) * 100 * 10
                          ) / 10
                        : 0;
            });

            return data;
        },

        // Generar datos temporales para gráficos
        generateTemporalData(period) {
            const data = [];
            const days = period === "semana" ? 7 : period === "mes" ? 30 : 90;

            for (let i = 0; i < days; i++) {
                const date = new Date();
                date.setDate(date.getDate() - (days - i - 1));

                data.push({
                    fecha: date.toISOString().split("T")[0],
                    solicitudes: Math.floor(Math.random() * 50 + 80),
                    resueltas: Math.floor(Math.random() * 40 + 60),
                    pendientes: Math.floor(Math.random() * 20 + 30),
                });
            }

            return data;
        },

        // Generar datos para el heatmap de SLA
        generateSLAHeatmap(period) {
            const data = [];
            const hours = ["00:00", "06:00", "12:00", "18:00", "24:00"];
            const days = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

            days.forEach((day) => {
                hours.forEach((hour) => {
                    if (hour !== "24:00") {
                        data.push({
                            dia: day,
                            hora: hour,
                            cumplimiento: Math.floor(Math.random() * 30 + 70),
                            solicitudes: Math.floor(Math.random() * 20 + 40),
                        });
                    }
                });
            });

            return data;
        },

        // Obtener rango de fechas según el período
        getDateRange(period) {
            const now = new Date();
            const inicio = new Date();

            switch (period) {
                case "semana":
                    inicio.setDate(now.getDate() - 7);
                    break;
                case "mes":
                    inicio.setMonth(now.getMonth() - 1);
                    break;
                case "trimestre":
                    inicio.setMonth(now.getMonth() - 3);
                    break;
                default:
                    inicio.setMonth(now.getMonth() - 1);
            }

            return {
                inicio: inicio.toISOString().split("T")[0],
                fin: now.toISOString().split("T")[0],
            };
        },

        async loadDashboardData() {
            this.loading = true;
            try {
                // Cargar KPIs, tema análisis, tema vencidas, demographics y agentes desde el controlador
                await Promise.all([
                    this.loadKPIs(),
                    this.loadTemaAnalisis(),
                    this.loadTemaVencidas(),
                    this.loadDemographics(),
                    this.loadAgentPerformance(),
                ]);

                // Generar el resto de datos fake
                this.generateOtherData();

                console.log("Dashboard cargado exitosamente");
            } catch (error) {
                console.error("Error cargando datos:", error);
                this.handleLoadError();
            } finally {
                this.loading = false;
            }
        },

        async loadKPIs() {
            try {
                const kpisUrl = this.buildKPIsUrl();
                const response = await fetch(kpisUrl);
                const result = await response.json();

                if (result.success) {
                    this.dashboardData.kpis = result.data;
                    console.log(
                        "KPIs cargados desde el controlador:",
                        result.data
                    );
                } else {
                    console.warn(
                        "Error cargando KPIs del controlador:",
                        result.message
                    );
                    throw new Error(result.message);
                }
            } catch (error) {
                console.error("Error cargando KPIs:", error);
                throw error;
            }
        },

        buildKPIsUrl() {
            let url = `/admin/dashboard-solicitudes/kpis?period=${this.selectedPeriod}`;

            if (this.customDates && this.selectedPeriod === "personalizado") {
                url += `&fecha_inicio=${this.customDates.startDate}&fecha_fin=${this.customDates.endDate}`;
            }

            return url;
        },

        async loadTemaAnalisis() {
            try {
                const temaUrl = this.buildTemaAnalisisUrl();
                const response = await fetch(temaUrl);
                const result = await response.json();

                if (result.success) {
                    this.dashboardData.temaAnalisis = result.data;
                    console.log(
                        "Tema análisis cargado desde el controlador:",
                        result.data
                    );
                } else {
                    console.warn(
                        "Error cargando tema análisis del controlador:",
                        result.message
                    );
                    throw new Error(result.message);
                }
            } catch (error) {
                console.error("Error cargando tema análisis:", error);
                throw error;
            }
        },

        buildTemaAnalisisUrl() {
            let url = `/admin/dashboard-solicitudes/tema-analisis?period=${this.selectedPeriod}`;

            if (this.customDates && this.selectedPeriod === "personalizado") {
                url += `&fecha_inicio=${this.customDates.startDate}&fecha_fin=${this.customDates.endDate}`;
            }

            return url;
        },

        async loadTemaVencidas() {
            try {
                const vencidasUrl = this.buildTemaVencidasUrl();
                const response = await fetch(vencidasUrl);
                const result = await response.json();

                if (result.success) {
                    this.dashboardData.temaVencidas = result.data;
                    console.log(
                        "Tema vencidas cargado desde el controlador:",
                        result.data
                    );
                } else {
                    console.warn(
                        "Error cargando tema vencidas del controlador:",
                        result.message
                    );
                    throw new Error(result.message);
                }
            } catch (error) {
                console.error("Error cargando tema vencidas:", error);
                throw error;
            }
        },

        buildTemaVencidasUrl() {
            let url = `/admin/dashboard-solicitudes/tema-vencidas?period=${this.selectedPeriod}`;

            if (this.customDates && this.selectedPeriod === "personalizado") {
                url += `&fecha_inicio=${this.customDates.startDate}&fecha_fin=${this.customDates.endDate}`;
            }

            return url;
        },

        async loadDemographics() {
            try {
                const demographicsUrl = this.buildDemographicsUrl();
                const response = await fetch(demographicsUrl);
                const result = await response.json();

                if (result.success) {
                    this.dashboardData.demographicsData = result.data;
                    console.log(
                        "Demographics cargado desde el controlador:",
                        result.data
                    );
                } else {
                    console.warn(
                        "Error cargando demographics del controlador:",
                        result.message
                    );
                    throw new Error(result.message);
                }
            } catch (error) {
                console.error("Error cargando demographics:", error);
                throw error;
            }
        },

        buildDemographicsUrl() {
            let url = `/admin/dashboard-solicitudes/demographics?period=${this.selectedPeriod}`;

            if (this.customDates && this.selectedPeriod === "personalizado") {
                url += `&fecha_inicio=${this.customDates.startDate}&fecha_fin=${this.customDates.endDate}`;
            }

            return url;
        },

        async loadAgentPerformance() {
            try {
                const agentUrl = this.buildAgentPerformanceUrl();
                const response = await fetch(agentUrl);
                const result = await response.json();

                if (result.success) {
                    this.dashboardData.agentePerformance = result.data;
                    console.log(
                        "Agent performance cargado desde el controlador:",
                        result.data
                    );
                } else {
                    console.warn(
                        "Error cargando agent performance del controlador:",
                        result.message
                    );
                    throw new Error(result.message);
                }
            } catch (error) {
                console.error("Error cargando agent performance:", error);
                throw error;
            }
        },

        buildAgentPerformanceUrl() {
            let url = `/admin/dashboard-solicitudes/agent-performance?period=${this.selectedPeriod}`;

            if (this.customDates && this.selectedPeriod === "personalizado") {
                url += `&fecha_inicio=${this.customDates.startDate}&fecha_fin=${this.customDates.endDate}`;
            }

            return url;
        },

        generateOtherData() {
            const fakeData = this.generateFakeData();
            const dataWithDerivedKPIs = this.calculateDerivedKPIs(fakeData);

            // Excluir KPIs, temaAnalisis, temaVencidas, demographicsData y agentePerformance de los datos fake y mantener solo los del controlador
            const {
                kpis,
                temaAnalisis,
                temaVencidas,
                demographicsData,
                agentePerformance,
                ...otherData
            } = dataWithDerivedKPIs;

            this.dashboardData = {
                ...otherData,
                kpis: this.dashboardData.kpis, // Mantener KPIs del controlador
                temaAnalisis: this.dashboardData.temaAnalisis, // Mantener tema análisis del controlador
                temaVencidas: this.dashboardData.temaVencidas, // Mantener tema vencidas del controlador
                demographicsData: this.dashboardData.demographicsData, // Mantener demographics del controlador
                agentePerformance: this.dashboardData.agentePerformance, // Mantener agentes del controlador
                periodo: this.selectedPeriod,
            };
        },

        handleLoadError() {
            const fakeData = this.generateFakeData();
            const dataWithDerivedKPIs = this.calculateDerivedKPIs(fakeData);

            // Excluir KPIs, temaAnalisis, temaVencidas, demographicsData y agentePerformance de los datos fake en caso de error
            const {
                kpis,
                temaAnalisis,
                temaVencidas,
                demographicsData,
                agentePerformance,
                ...otherData
            } = dataWithDerivedKPIs;

            this.dashboardData = {
                ...this.dashboardData,
                ...otherData,
                periodo: this.selectedPeriod,
            };

            this.showError(
                "Error al cargar los datos del dashboard, usando datos de ejemplo"
            );
        },

        onPeriodChanged(period) {
            this.selectedPeriod = period;
            this.customDates = null; // Limpiar fechas personalizadas
            this.loadDashboardData();
        },

        onCustomPeriodApplied(customDates) {
            // Implementar lógica para período personalizado
            console.log("Período personalizado aplicado:", customDates);
            this.customDates = customDates;
            this.selectedPeriod = "personalizado";
            this.loadDashboardData();
        },

        initializeRealTimeUpdates() {
            // Actualizar datos cada 5 minutos con nuevos datos fake
            this.refreshInterval = setInterval(() => {
                this.loadDashboardData();
            }, 300000); // 5 minutos
        },

        showError(message) {
            console.error(message);
            // Aquí podrías implementar una notificación de error
        },

        async regenerateFakeData() {
            this.loading = true;
            try {
                await Promise.all([
                    this.loadKPIs(),
                    this.loadTemaAnalisis(),
                    this.loadTemaVencidas(),
                    this.loadDemographics(),
                    this.loadAgentPerformance(),
                ]);
                this.generateOtherData();
                console.log("Datos regenerados.");
            } catch (error) {
                console.error("Error regenerando datos:", error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.dashboard-solicitudes {
    padding: 20px;
}

.dashboard-header {
    background: linear-gradient(135deg, #1f4e79 0%, #2c5aa0 100%);
    color: white;
    border-radius: 12px;
    padding: 20px 25px;
}

.dashboard-header-subtitle {
    font-size: 14px;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-content {
    text-align: center;
    background: white;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.loading-content i {
    color: #1f4e79;
    margin-bottom: 15px;
}

.loading-content p {
    margin: 0;
    color: #6c757d;
    font-weight: 500;
}

.ibox-tools {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ibox-tools .btn-outline-light {
    border: 1px solid rgba(255, 255, 255, 0.5);
    color: white;
    transition: all 0.3s ease;
}

.ibox-tools .btn-outline-light:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: white;
    transform: translateY(-1px);
}

.ibox-tools .btn-outline-light:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
</style>
